import { GetProgrammaticCampaignOverallVideoViewsRO } from "@intentsify/dto";
import { apiService, Endpoints } from "api";
import { DisplayPerformanceFilters } from "screens/CampaignPacing/screens/DisplayPerformance/DisplayPerformance";

export const getOverallVideoViews = async (
  id: string,
  filters: DisplayPerformanceFilters
): Promise<GetProgrammaticCampaignOverallVideoViewsRO> => {
  const { data } =
    await apiService.get<GetProgrammaticCampaignOverallVideoViewsRO>(
      Endpoints.ProgrammaticCampaigns.CreativeEngagement.Get.OverallVideoMap(
        id
      ),
      {
        params: {
          yearFrom: filters.yearFrom,
          yearTo: filters.yearTo,
          weekFrom: filters.weekFrom,
          weekTo: filters.weekTo,
        },
      }
    );
  return data;
};
